import { Image, MediaFile } from '@shopify/hydrogen'
import { ExternalVideo, MediaImage, Model3d, Video } from '@shopify/hydrogen/storefront-api-types'
import { useContext, useEffect, useRef, useState } from 'react'
import styles from '../../assets/scss/components/products/products.module.scss'
import { BreakpointsContext } from '../layout/breakpoints-provider.client'
import { ProductLayoutContext } from './product-layout-provider.client'
import { useIsomorphicLayoutEffect } from 'usehooks-ts'
import { useI18n } from '../i18n.client'
import { motion, useMotionValue, useScroll } from 'framer-motion'

export const ProductGallery: React.FC<{ mediaNodes: (ExternalVideo | MediaImage | Model3d | Video)[] }> = ({
  mediaNodes,
}) => {
  const { productSummaryHeight } = useContext(ProductLayoutContext)
  const [i18n] = useI18n()
  const ref = useRef<HTMLDivElement>(null)
  const { scrollXProgress } = useScroll({ container: ref })
  const { scrollYProgress } = useScroll()
  const opacity = useMotionValue(1)
  const [top, setTop] = useState('0px')

  useEffect(() => {
    const unsubscribeScrollXProgress = scrollXProgress.onChange((x) => {
      opacity.set(Math.max(1 - 20 * x, 0))
    })

    const unsubscribeScrollYProgress = scrollYProgress.onChange((y) => {
      opacity.set(Math.max(1 - 20 * y, 0))
    })

    return () => {
      unsubscribeScrollXProgress()
      unsubscribeScrollYProgress()
    }
  }, [])

  useIsomorphicLayoutEffect(() => {
    setTop(`${window.innerHeight - (productSummaryHeight ?? 0)}px`)
  }, [productSummaryHeight])

  return (
    <div className={styles.mediaScrollContainer} ref={ref}>
      <motion.div className={styles.swipeToExplore} style={{ opacity, top }}>
        {i18n.translate('swipe-to-explore')}
        <Image alt={i18n.translate('swipe-to-explore')} height={8} src="/carousel-arrow.svg" width={27} />
      </motion.div>
      <Gallery mediaNodes={mediaNodes} />
    </div>
  )
}

const Gallery: React.FC<{ mediaNodes: (ExternalVideo | MediaImage | Model3d | Video)[] }> = ({ mediaNodes }) => {
  const { isMediumUp } = useContext(BreakpointsContext)
  const { productSummaryHeight } = useContext(ProductLayoutContext)
  const [height, setHeight] = useState('auto')

  useIsomorphicLayoutEffect(() => {
    // Hard-coded header height
    setHeight(!isMediumUp ? `${window.innerHeight - (productSummaryHeight ?? 0) - 82}px` : 'auto')
  }, [productSummaryHeight])

  if (!mediaNodes.length) {
    return (
      <Image
        alt=""
        className={styles.media}
        height="1283"
        src="https://dummyimage.com/1444x1283"
        style={{ height }}
        width="1444"
      />
    )
  }

  return (
    <>
      {mediaNodes.map((media) => (
        <MediaFile className={styles.media} data={media} key={media.id} style={{ height }} />
      ))}
    </>
  )
}
